import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"25px"} }, "Teacher's Debug Page", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "ruthenian-blue heeej" }

import tabMenu from '@/common/components/snedson-material-components/tab-menu/tab-menu.vue';
import dataTag from '@/common/components/snedson-material-components/data-tag/data-tag.vue';
import onAir from '@/common/components/snedson-material-components/on-air/on-air.vue';
import CustomButton from '@/common/components/snedson-material-components/custom-button/custom-button.vue';
import { reactive } from 'vue';
import router from '@/router';
import whatever from '@/assets/icons/emojis/teacher.png';
import UniversalCard from '@/common/components/snedson-material-components/universal-card/universal-card.vue';
import MaterialShapedIcon from '@/common/components/helper-components/material-shape-container/material-shaped-icon/material-shaped-icon.vue';
import MaterialShapedButton from '@/common/components/helper-components/material-shape-container/material-shaped-button/material-shaped-button.vue';
import MaterialShapeContainer from '@/common/components/helper-components/material-shape-container/material-shape-container.vue';

// import { TAnimationFlows } from '@/common/types/TAnimationFlows';
// import { HandleAnimation } from '@/services/useAnimations';

// const emit = defineEmits<{
//     (e: 'changeFlow', flow: TAnimationFlows): void;
// }>();


export default /*#__PURE__*/_defineComponent({
  __name: 'DebugPage',
  setup(__props) {

const tabs = reactive({
    tabs: [
        {
            id: 0,
            title: 'Подстраница 1',
            iconUrl: '',
        },
        {
            id: 1,
            title: 'Подстраница 2',
            iconUrl: '',
        },
    ],
    selected: 0,
});

// const setSelectedTab = (selectedId) => {
//     var direction = HandleAnimation('horizontal', tabs.selected, selectedId);
//     tabs.selected = selectedId;
//     emit('changeFlow', direction);

//     if (selectedId == 0) {
//         router.push({ name: 'sn.teacher.debug.1' });
//     } else {
//         router.push({ name: 'sn.teacher.debug.2' });
//     }
// };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(tabMenu, {
      props: {
            tabs: tabs.tabs,
            selectedTabItemId: tabs.selected,
        }
    }, null, 8, ["props"]),
    _hoisted_1,
    (tabs.selected == 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Subpage 1"))
      : _createCommentVNode("", true),
    (tabs.selected == 1)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Subpage 2"))
      : _createCommentVNode("", true),
    _createVNode(dataTag, { props: {
            title: 'Весь класс',
            color: 'var(--snotra--surfaces--surface1)',
            iconLocal: 'teacher.png',
        } }, null, 8, ["props"]),
    _createVNode(onAir, { style: {"margin-top":"15px"} }),
    _createVNode(MaterialShapedButton, {
      props: {
            icon: 'arrow_forward',
        },
      class: "msb sn-msc-button-on-minor-card"
    }),
    _createVNode(MaterialShapeContainer, {
      class: "sn-msc-on-universal-card",
      props: { shape: 'four-pointed-shape', strokeWidth: 0 }
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(CustomButton, { props: {
                size: 'icon-only-large',
                type: 'outlined',
                //        colorSchemeName: 'ruthenian-red',
                iconName: 'edit',
            } }),
      _createVNode(CustomButton, { props: {
                size: 'full',
                type: 'filled',
                //        colorSchemeName: 'ruthenian-red',
                iconName: 'dashboard',
                innerText: 'Измененное расписание',
            } })
    ]),
    _createVNode(CustomButton, { props: {
            size: 'icon-only-large',
            type: 'outlined',

            //        colorSchemeName: 'ruthenian-red',
            iconName: 'dashboard',
        } }),
    _createVNode(CustomButton, { props: {
            size: 'icon-only-large',
            type: 'outlined-transparent',
            //        colorSchemeName: 'ruthenian-red',
            iconName: 'dashboard',
        } }),
    _createVNode(CustomButton, { props: {
            size: 'icon-only-small',
            type: 'outlined',
            //        colorSchemeName: 'ruthenian-red',
            iconName: 'dashboard',
        } }),
    _createVNode(UniversalCard, {
      props: {
            title: '1. Обществознание',
            content: 'Лорем ипсум',
            buttons: [
                {
                    iconName: 'supervised_user_circle',
                    type: 'outlined',
                    size: 'icon-only-large',
                },
                {
                    iconName: 'edit',
                    innerText: 'Изменить данные урока',
                    type: 'filled',
                    size: 'full',
                },
            ],
            isOnAir: false,
            dataTags: [
                {
                    title: '8:30 - 9:15 (45 мин.)',
                    color: 'var(--snotra--surfaces--surface1)',
                    iconCompleteUrl: _unref(whatever),
                },
                {
                    title: 'Кабинет 24',
                    color: 'var(--snotra--surfaces--surface1)',
                    iconCompleteUrl: _unref(whatever),
                },
                {
                    title: 'Весь класс',
                    color: 'var(--snotra--surfaces--surface1)',
                    iconCompleteUrl: _unref(whatever),
                },
                {
                    title: 'Перемена после: 15 минут',
                    color: 'var(--snotra--surfaces--surface1)',
                    iconCompleteUrl: _unref(whatever),
                },
            ],
            icon: _unref(whatever),
            type: 'outlined',
        }
    }, null, 8, ["props"]),
    _createVNode(MaterialShapedIcon, { props: {
            color: 'hej',
            shape: 'ten-pointed-shape',
            iconCompleteUrl: '',
        } })
  ], 64))
}
}

})